export default __webpack_public_path__ + "static/service-consulting-banner-df7119d3bf5cefa74ebc68d4dd92ef15.png";